<div class="modal-signup modal-content" *ngIf="ModelType=='Edit Items'">
  <div>
    <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">


      <div class="card-header wh-header padding-bottom-0px padding-left-10px">

        Edit Items

        <button type="button" class="close" data-dismiss="modal"
                (click)="activeModal.dismiss('Cross click')"
                aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="card-body padding-bottom-0px padding-right-0px margin-left-0px padding-left-0px padding-top-0px">
        <div class="row border-top border-bottom bk-color-light margin-left-zero margin-right-0px">
          <div class="col-md-3  text-align-center padding-right-0px padding-left-0px border-right-1px">
            <div class="margin-top-10"><h4 class=" font-weight-bold margin-bottom-0px label-color-consultant font-size-12px">Customer Name</h4></div>
            <div class="margin-bottom-10px"><h4 class="margin-bottom-0px display-inline color-Checkin"> Piyali Sarkar</h4></div>
          </div>
          <div class="col-md-3  text-align-center padding-right-0px padding-left-0px border-right-1px">
            <div class="margin-top-10"><h4 class="font-weight-bold margin-bottom-0px label-color-consultant font-size-12px">Order Id</h4></div>
            <div class="margin-bottom-10px"><h4 class="margin-bottom-0px display-inline color-Assign">#12344</h4></div>
          </div>
          <div class="col-md-3 text-align-center padding-right-0px padding-left-0px border-right-1px">
            <div class="margin-top-10"><h4 class=" font-weight-bold margin-bottom-0px label-color-consultant font-size-12px">Order Date</h4></div>
            <div class="margin-bottom-10px"><h4 class="margin-bottom-0px display-inline">OCT-12-2020</h4> </div>
          </div>
          <div class="col-md-3 text-align-center padding-right-0px padding-left-0px border-right-1px">
            <div class="margin-top-10"><h4 class=" font-weight-bold margin-bottom-0px label-color-consultant font-size-12px">Deliver To</h4></div>
            <div class="margin-bottom-10px"><h4 class="margin-bottom-0px display-inline color-checkout">Nacharam, Hyd</h4></div>
          </div>


          <!--<div class="col-md-3  text-align-center padding-right-0px padding-left-0px border-right-1px">
    <div class="margin-top-10"><h4 class=" font-weight-bold margin-bottom-0px label-color-consultant font-size-12px">Item Name</h4></div>
    <div class="margin-bottom-10px"><h4 class="margin-bottom-0px display-inline"> Consultant</h4></div>
  </div>
  <div class="col-md-3  text-align-center padding-right-0px padding-left-0px border-right-1px">
    <div class="margin-top-10"><h4 class="font-weight-bold margin-bottom-0px label-color-consultant font-size-12px">Requst Qty</h4></div>
    <div class="margin-bottom-10px"><h4 class="margin-bottom-0px display-inline">2</h4></div>
  </div>-->
        </div>
        <div class="row">
          <div class="col-md-6 padding-right-9px padding-left-10px">
            <div class="row font-size-14 margin-top-10 margin-left-0px">
              <div class="col-md-3 text-align-right">
                <label class="margin-bottom-0px">Date </label>
              </div>:
              <div class="col-md-7  padding-left-10px my-profile-form">

                <div class="form-group margin-bottom-0px">
                  <!--<CodeTypeValue CodeType="FNSTS"></CodeTypeValue>-->
                  <!--id="CurrentSaveSingleEmbryoGradeInfoRequest.Grade"
        [(ngModel)]="CurrentSaveSingleEmbryoGradeInfoRequest.Grade" SelectedValue="CurrentSaveSingleEmbryoGradeInfoRequest.Grade"
        name="CurrentSaveSingleEmbryoGradeInfoRequest.Grade">-->

                  <h4 class="margin-bottom-0px  margin-top-3px">OCT-23-2020</h4>


                </div>


              </div>

            </div>
          </div>
          <div class="offset-md-2 col-md-4 padding-right-0px">
            <div class="row font-size-14 margin-top-10">
              <div class="col-md-4 text-align-right padding-left-0px padding-right-10px">
                <label class="margin-bottom-0px">Time </label>
              </div>:
              <div class="col-md-7  padding-left-10px my-profile-form padding-right-0px">

                <div class="form-group margin-bottom-0px">
                  <!--<CodeTypeValue CodeType="FNSTS"></CodeTypeValue>-->
                  <!--id="CurrentSaveSingleEmbryoGradeInfoRequest.Grade"
        [(ngModel)]="CurrentSaveSingleEmbryoGradeInfoRequest.Grade" SelectedValue="CurrentSaveSingleEmbryoGradeInfoRequest.Grade"
        name="CurrentSaveSingleEmbryoGradeInfoRequest.Grade">-->

                  <h4 class="margin-bottom-0px  margin-top-3px">07:00PM</h4>


                </div>


              </div>

            </div>
          </div>
        </div>
        <form class="form" novalidate="" (ngSubmit)="onSubmit()" #f="ngForm">
          <div class="modal-body padding-top-0px margin-top-5px">








            <div class="row margin-left-auto">
              <div class="col-md-12 padding-l-0px">

                <!--<div class="card-header wh-header card-header-bg padding-left-7px padding-top-6px margin-top-10">
    Emergency Contact(Family)


  </div>-->
                <div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row font-size-14 margin-top-10">
                      <div class="col-md-4 text-align-right padding-left-0px">
                        <label class="margin-bottom-0px">Item Name </label>
                      </div>:
                      <div class="col-md-7  padding-left-10px my-profile-form">

                        <div class="form-group margin-bottom-0px">
                          <!--<CodeTypeValue CodeType="FNSTS"></CodeTypeValue>-->
                          <!--id="CurrentSaveSingleEmbryoGradeInfoRequest.Grade"
        [(ngModel)]="CurrentSaveSingleEmbryoGradeInfoRequest.Grade" SelectedValue="CurrentSaveSingleEmbryoGradeInfoRequest.Grade"
        name="CurrentSaveSingleEmbryoGradeInfoRequest.Grade">-->

                          <h4 class="color-Assign margin-bottom-0px font-weight-bold margin-top-3px">Consultant</h4>


                        </div>


                      </div>

                    </div>
                  </div>
                </div>
                
                
                <div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-0px">
                    <div class="row font-size-14 margin-top-0px">
                      <div class="col-md-4 text-align-right padding-left-0px">
                        <label class="margin-bottom-0px">Requested Qunatity </label>
                      </div>:
                      <div class="col-md-7  padding-left-10px my-profile-form">

                        <div class="form-group margin-bottom-0px">
                          <!--<CodeTypeValue CodeType="FNSTS"></CodeTypeValue>-->
                          <!--id="CurrentSaveSingleEmbryoGradeInfoRequest.Grade"
      [(ngModel)]="CurrentSaveSingleEmbryoGradeInfoRequest.Grade" SelectedValue="CurrentSaveSingleEmbryoGradeInfoRequest.Grade"
      name="CurrentSaveSingleEmbryoGradeInfoRequest.Grade">-->

                          <h4 class="color-Assign margin-bottom-0px font-weight-bold margin-top-3px">2PCS</h4>


                        </div>


                      </div>

                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-4 text-align-right">
                        <label for="diaplayName" class="margin-bottom-0px margin-top-7px"><span>*</span> Issue Quantity</label>
                      </div>

                      <div class="col-md-4">
                        <!--<CodeTypeValue CodeType="RELTP"
               id="CurrentActorEditEmergencyInfoRequest.RelationType"
           [(ngModel)]="CurrentActorEditEmergencyInfoRequest.RelationType" SelectedValue="{{CurrentActorEditEmergencyInfoRequest.RelationType}}"
          name="CurrentActorEditEmergencyInfoRequest.RelationType">
           </CodeTypeValue>-->
                        <!--<label>{{CurrentActorEditEmergencyInfoRequest.RelationType}}</label>-->
                        <!--<input type="text" class="form-control" id="CurrentActorEditEmergencyInfoRequest.RelationType"
                 [(ngModel)]="CurrentActorEditEmergencyInfoRequest.RelationType"
                 name="CurrentActorEditEmergencyInfoRequest.RelationType"
                 placeholder="Relation Name" maxlength="20" minlength="1" #RelationType="ngModel" pattern="^[\sa-zA-Z0-9,/._\-?]*$">
          <small class="form-text text-danger"
                 *ngIf="(!RelationType.valid && (RelationType.dirty || RelationType.touched) && RelationType.errors.required)">(Field cannot be left blank)</small>
          <small class="form-text text-danger"
                 *ngIf="(!RelationType.valid && RelationType.errors.pattern)">(special characters are not allowed)</small>-->
                        <input type="text" class="form-control"
                               placeholder="Count" maxlength="5" minlength="1" pattern="^[\0-9,._\-?]*$">
                        <!--<small class="form-text text-danger"
                 *ngIf="(!Ntimes.valid && (Ntimes.dirty || Ntimes.touched) && Ntimes.errors.required)">(Field cannot be left blank)</small>
          <small class="form-text text-danger"
                 *ngIf="(!Ntimes.valid && Ntimes.errors.pattern)">(only numbers are allowed)</small>-->



                      </div>

                    </div>


                  </div>
                </div>

                <div class="row">

                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-4 text-align-right">

                        <label for="firstName" class="margin-bottom-0px margin-top-7px"> Comments</label>
                      </div>
                      <div class="col-md-4">

                        <CodeTypeValue CodeType="FNSTS">


                        </CodeTypeValue>
                      </div>

                    </div>

                  </div>
                </div>






              </div>
            </div>


            <!--<div class="card-footer text-align-center">
        <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto" (click)="activeModal.close('Close click')">Close</button>
      </div>-->


















          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto font-size-13px" (click)="activeModal.close('Close click')">Close</button>
            <button type="submit" class="btn actions-btn-prime float-right font-size-13px margin-right-auto">Save</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
<div class="modal-signup modal-content" *ngIf="ModelType=='View Items'">
  <div>
    <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">


      <div class="card-header wh-header padding-bottom-0px padding-left-10px">

        View Items(Ivf &#64; Home)

        <button type="button" class="close" data-dismiss="modal"
                (click)="activeModal.dismiss('Cross click')"
                aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="card-body padding-bottom-0px padding-right-0px margin-left-0px padding-left-0px padding-top-0px">
        <div class="row border-top border-bottom bk-color-light margin-left-zero margin-right-0px">
          <div class="col-md-3  text-align-center padding-right-0px padding-left-0px border-right-1px">
            <div class="margin-top-10"><h4 class=" font-weight-bold margin-bottom-0px label-color-consultant font-size-12px">Patient Name</h4></div>
            <div class="margin-bottom-10px"><h4 class="margin-bottom-0px display-inline color-Checkin" *ngIf="CustomerName"> {{CustomerName}}</h4></div>
          </div>
          <div class="col-md-3  text-align-center padding-right-0px padding-left-0px border-right-1px">
            <div class="margin-top-10"><h4 class="font-weight-bold margin-bottom-0px label-color-consultant font-size-12px">Ivf&#64;Home Order</h4></div>
            <div class="margin-bottom-10px"><h4 class="margin-bottom-0px display-inline color-Assign" *ngIf="OrderCode">#{{OrderCode}}</h4></div>
          </div>
          <div class="col-md-3 text-align-center padding-right-0px padding-left-0px border-right-1px">
            <div class="margin-top-10"><h4 class=" font-weight-bold margin-bottom-0px label-color-consultant font-size-12px">Order Date</h4></div>
            <div class="margin-bottom-10px"><h4 class="margin-bottom-0px display-inline" *ngIf="OrderDate">{{OrderDate | date:'MMM-dd-yyyy'}}</h4> </div>
          </div>
          <div class="col-md-3 text-align-center padding-right-0px padding-left-0px border-right-1px">
            <div class="margin-top-10"><h4 class=" font-weight-bold margin-bottom-0px label-color-consultant font-size-12px">Address</h4></div>
            <div class="margin-bottom-10px td-elipsis2 padding-left-10px"><h4 class="margin-bottom-0px display-inline color-checkout" *ngIf="Address">{{Address}}</h4></div>
          </div>


          <!--<div class="col-md-3  text-align-center padding-right-0px padding-left-0px border-right-1px">
    <div class="margin-top-10"><h4 class=" font-weight-bold margin-bottom-0px label-color-consultant font-size-12px">Item Name</h4></div>
    <div class="margin-bottom-10px"><h4 class="margin-bottom-0px display-inline"> Consultant</h4></div>
  </div>
  <div class="col-md-3  text-align-center padding-right-0px padding-left-0px border-right-1px">
    <div class="margin-top-10"><h4 class="font-weight-bold margin-bottom-0px label-color-consultant font-size-12px">Requst Qty</h4></div>
    <div class="margin-bottom-10px"><h4 class="margin-bottom-0px display-inline">2</h4></div>
  </div>-->
        </div>
        <div class="row">
          <div class="col-md-6 padding-right-9px padding-left-0px">
            <div class="row font-size-14 margin-top-10 margin-left-0px">
              <div class="col-md-3 text-align-right">
                <label class="margin-bottom-0px">Date </label>
              </div>:
              <div class="col-md-7  padding-left-10px my-profile-form">

                <div class="form-group margin-bottom-0px">
                  <!--<CodeTypeValue CodeType="FNSTS"></CodeTypeValue>-->
                  <!--id="CurrentSaveSingleEmbryoGradeInfoRequest.Grade"
                  [(ngModel)]="CurrentSaveSingleEmbryoGradeInfoRequest.Grade" SelectedValue="CurrentSaveSingleEmbryoGradeInfoRequest.Grade"
                  name="CurrentSaveSingleEmbryoGradeInfoRequest.Grade">-->

                  <h4 class="margin-bottom-0px  margin-top-3px" *ngIf="ScheduleDate">{{ScheduleDate |date:'MMM-dd-yyyy'}}</h4>


                </div>


              </div>

            </div>
          </div>
          <div class="offset-md-2 col-md-4 padding-right-0px">
            <div class="row font-size-14 margin-top-10">
              <div class="col-md-4 text-align-right padding-left-0px padding-right-10px">
                <label class="margin-bottom-0px">Time </label>
              </div>:
              <div class="col-md-7  padding-left-10px my-profile-form padding-right-0px">

                <div class="form-group margin-bottom-0px">
                  <!--<CodeTypeValue CodeType="FNSTS"></CodeTypeValue>-->
                  <!--id="CurrentSaveSingleEmbryoGradeInfoRequest.Grade"
                  [(ngModel)]="CurrentSaveSingleEmbryoGradeInfoRequest.Grade" SelectedValue="CurrentSaveSingleEmbryoGradeInfoRequest.Grade"
                  name="CurrentSaveSingleEmbryoGradeInfoRequest.Grade">-->

                  <h4 class="margin-bottom-0px  margin-top-3px" *ngIf="ScheduleDate">{{ScheduledTime| date: 'mediumTime'}}</h4>


                </div>


              </div>

            </div>
          </div>
        </div>
        <form class="form" novalidate="" (ngSubmit)="onSubmit()" #f="ngForm">
          <div class="modal-body padding-top-0px margin-top-5px">








            <div class="row margin-left-auto">
              <div class="col-md-12 padding-l-0px">

                <!--<div class="card-header wh-header card-header-bg padding-left-7px padding-top-6px margin-top-10">
    Emergency Contact(Family)


  </div>-->
                <div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row font-size-14 margin-top-10">
                      <div class="col-md-4 text-align-right padding-left-0px">
                        <label class="margin-bottom-0px">Service Name </label>
                      </div>:
                      <div class="col-md-7  padding-left-10px my-profile-form">

                        <div class="form-group margin-bottom-0px">
                          <!--<CodeTypeValue CodeType="FNSTS"></CodeTypeValue>-->
                          <!--id="CurrentSaveSingleEmbryoGradeInfoRequest.Grade"
            [(ngModel)]="CurrentSaveSingleEmbryoGradeInfoRequest.Grade" SelectedValue="CurrentSaveSingleEmbryoGradeInfoRequest.Grade"
            name="CurrentSaveSingleEmbryoGradeInfoRequest.Grade">-->

                          <h4 class="color-Assign margin-bottom-0px font-weight-bold margin-top-3px" *ngIf="ServiceName">{{ServiceName}}</h4>


                        </div>


                      </div>

                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row font-size-14 ">
                      <div class="col-md-4 text-align-right padding-left-0px">
                        <label class="margin-bottom-0px">Provider </label>
                      </div>:
                      <div class="col-md-7  padding-left-10px my-profile-form">

                        <div class="form-group margin-bottom-0px">
                          <!--<CodeTypeValue CodeType="FNSTS"></CodeTypeValue>-->
                          <!--id="CurrentSaveSingleEmbryoGradeInfoRequest.Grade"
            [(ngModel)]="CurrentSaveSingleEmbryoGradeInfoRequest.Grade" SelectedValue="CurrentSaveSingleEmbryoGradeInfoRequest.Grade"
            name="CurrentSaveSingleEmbryoGradeInfoRequest.Grade">-->

                          <h4 class="color-Assign margin-bottom-0px font-weight-bold margin-top-3px" *ngIf="AssignedNmae">{{AssignedNmae}}</h4>


                        </div>


                      </div>

                    </div>
                  </div>
                </div>

            
                <div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-0px">
                    <div class="row font-size-14 margin-top-0px">
                      <div class="col-md-4 text-align-right padding-left-0px">
                        <label class="margin-bottom-0px">Status </label>
                      </div>:
                      <div class="col-md-7  padding-left-10px my-profile-form">

                        <div class="form-group margin-bottom-0px">
                          <!--<CodeTypeValue CodeType="FNSTS"></CodeTypeValue>-->
                          <!--id="CurrentSaveSingleEmbryoGradeInfoRequest.Grade"
            [(ngModel)]="CurrentSaveSingleEmbryoGradeInfoRequest.Grade" SelectedValue="CurrentSaveSingleEmbryoGradeInfoRequest.Grade"
            name="CurrentSaveSingleEmbryoGradeInfoRequest.Grade">-->

                          <h4 class="color-Assign margin-bottom-0px font-weight-bold margin-top-3px" *ngIf="OrderStatus">{{OrderStatus}}</h4>


                        </div>


                      </div>

                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-0px">
                    <div class="row font-size-14 margin-top-0px">
                      <div class="col-md-4 text-align-right padding-left-0px">
                        <label class="margin-bottom-0px">Comments </label>
                      </div>:
                      <div class="col-md-7  padding-left-10px my-profile-form">

                        <div class="form-group margin-bottom-0px">
                          <!--<CodeTypeValue CodeType="FNSTS"></CodeTypeValue>-->
                          <!--id="CurrentSaveSingleEmbryoGradeInfoRequest.Grade"
            [(ngModel)]="CurrentSaveSingleEmbryoGradeInfoRequest.Grade" SelectedValue="CurrentSaveSingleEmbryoGradeInfoRequest.Grade"
            name="CurrentSaveSingleEmbryoGradeInfoRequest.Grade">-->

                          <h4 class="margin-bottom-0px  margin-top-3px" *ngIf="Comments">{{Comments}}</h4>


                        </div>


                      </div>

                    </div>
                  </div>
                </div>
                






              </div>
            </div>


            <!--<div class="card-footer text-align-center">
              <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto" (click)="activeModal.close('Close click')">Close</button>
            </div>-->


















          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto font-size-13px" (click)="activeModal.close('Close click')">Close</button>
            <!--<button type="submit" class="btn actions-btn-prime float-right font-size-13px margin-right-auto">Save</button>-->
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
<div class="modal-signup modal-content" *ngIf="ModelType=='Track Items'">
  <div>
    <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">


      <div class="card-header wh-header padding-bottom-0px padding-left-10px">

        Track Status(Ivf &#64; Home)

        <button type="button" class="close" data-dismiss="modal"
                (click)="activeModal.dismiss('Cross click')"
                aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="card-body padding-bottom-0px padding-right-0px margin-left-0px padding-left-0px padding-top-0px">
        <div class="row border-top border-bottom bk-color-light margin-left-zero margin-right-0px">
          <div class="col-md-3  text-align-center padding-right-0px padding-left-0px border-right-1px">
            <div class="margin-top-10"><h4 class=" font-weight-bold margin-bottom-0px label-color-consultant font-size-12px">Patient Name</h4></div>
            <div class="margin-bottom-10px"><h4 class="margin-bottom-0px display-inline color-Checkin" *ngIf="CustomerName"> {{CustomerName}}</h4></div>
          </div>
          <div class="col-md-3  text-align-center padding-right-0px padding-left-0px border-right-1px">
            <div class="margin-top-10"><h4 class="font-weight-bold margin-bottom-0px label-color-consultant font-size-12px">Ivf&#64;Home Order</h4></div>
            <div class="margin-bottom-10px"><h4 class="margin-bottom-0px display-inline color-Assign" *ngIf="OrderCode">#{{OrderCode}}</h4></div>
          </div>
          <div class="col-md-3 text-align-center padding-right-0px padding-left-0px border-right-1px">
            <div class="margin-top-10"><h4 class=" font-weight-bold margin-bottom-0px label-color-consultant font-size-12px">Order Date</h4></div>
            <div class="margin-bottom-10px"><h4 class="margin-bottom-0px display-inline" *ngIf="OrderDate">{{OrderDate | date:'MMM-dd-yyyy'}}</h4> </div>
          </div>
          <div class="col-md-3 text-align-center padding-right-0px padding-left-0px border-right-1px">
            <div class="margin-top-10"><h4 class=" font-weight-bold margin-bottom-0px label-color-consultant font-size-12px">Address</h4></div>
            <div class="margin-bottom-10px td-elipsis2 padding-left-10px"><h4 class="margin-bottom-0px display-inline color-checkout" *ngIf="Address">{{Address}}</h4></div>
          </div>

          <!--<div class="col-md-3  text-align-center padding-right-0px padding-left-0px border-right-1px">
    <div class="margin-top-10"><h4 class=" font-weight-bold margin-bottom-0px label-color-consultant font-size-12px">Item Name</h4></div>
    <div class="margin-bottom-10px"><h4 class="margin-bottom-0px display-inline"> Consultant</h4></div>
  </div>
  <div class="col-md-3  text-align-center padding-right-0px padding-left-0px border-right-1px">
    <div class="margin-top-10"><h4 class="font-weight-bold margin-bottom-0px label-color-consultant font-size-12px">Requst Qty</h4></div>
    <div class="margin-bottom-10px"><h4 class="margin-bottom-0px display-inline">2</h4></div>
  </div>-->
        </div>
        <div class="row">
          <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
            <div class="row font-size-14 margin-top-10">
              <div class="col-md-5 text-align-right padding-left-0px">
                <label class="margin-bottom-0px">Service Name </label>
              </div>:
              <div class="col-md-6  padding-left-10px my-profile-form">

                <div class="form-group margin-bottom-0px">
                  <!--<CodeTypeValue CodeType="FNSTS"></CodeTypeValue>-->
                  <!--id="CurrentSaveSingleEmbryoGradeInfoRequest.Grade"
        [(ngModel)]="CurrentSaveSingleEmbryoGradeInfoRequest.Grade" SelectedValue="CurrentSaveSingleEmbryoGradeInfoRequest.Grade"
        name="CurrentSaveSingleEmbryoGradeInfoRequest.Grade">-->

                  <h4 class="color-Assign margin-bottom-0px font-weight-bold margin-top-3px" *ngIf="ServiceName">{{ServiceName}}</h4>


                </div>


              </div>

            </div>
            <div class="row margin-top-3px bk-color-light margin-left-0px margin-right-0px">

            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-4 text-align-right">

                  <label for="firstName" class="margin-bottom-0px margin-top-7px"> Comments</label>
                </div>
                <div class="col-md-4">

                  <textarea class="form-control3 size-2 width-inherit" rows="2" placeholder="Concerns"
                            name="CurrentSaveIahOrderItemStatusRequest.Comments"
                            [(ngModel)]="CurrentSaveIahOrderItemStatusRequest.Comments" minlength="1" maxlength="100"
                            #addconcerns_text1="ngModel" required></textarea>
                  <small class="form-text text-danger"
                         *ngIf="(!addconcerns_text1.valid && (addconcerns_text1.dirty || addconcerns_text1.touched))">(Required)</small>

                </div>

              </div>

            </div>
          </div>
          </div>
        </div>


      </div>

      <div class="accordion padding-10px" id="accordionExampleAss">
        <form class="form " novalidate="" (ngSubmit)="onSubmitProvider()" #f="ngForm">
          <div class="card margin-bottom-5px">
            <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingAss">
              <div class="row">
                <div class="col-md-4">
                  <h5 class="mb-0 height-24px">
                    <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseAss" aria-expanded="true" aria-controls="collapseAss">
                      Assign
                    </button>
                  </h5>
                </div>
                <div class="col-md-8">
                  <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                  <button type="submit" class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>
                </div>
                <!--<div class="col-md-6">
              <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto">Clear</button>
              <button type="submit" class="btn font-size-13px actions-btn-prime margin-right-auto">Save</button>
            </div>-->
              </div>


            </div>

            <div id="collapseAss" class="collapse show" aria-labelledby="headingAss" data-parent="#accordionExampleAss">
              <div class="card-body padding-top-0px padding-bottom-0px margin-left-0px padding-left-0px padding-right-0px">

                <div class="card margin-bottom-0px ">

                  <div class="card-body padding-top-0px padding-bottom-0px padding-left-0px padding-right-0px">

                    <div class="row">

                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                        <div class="row">
                          <div class="col-md-4 text-align-right">

                            <label for="firstName" class="margin-bottom-0px margin-top-7px">Provider</label>
                          </div>
                          <div class="col-md-4">

                            <CustomDataByRequestType RequestedType="EmployeeActorCodeByFacility" ActorCode={{ActorCode}} FacilityCode={{FacilityCode}}
                                                     id="CurrentSaveIahOrderItemStatusRequest.AssignedTo" SelectedValue="CurrentSaveIahOrderItemStatusRequest.AssignedTo"
                                                     [(ngModel)]="CurrentSaveIahOrderItemStatusRequest.AssignedTo" (keyChange)="onAssignedToActorCodesurgeon($event)"
                                                     name="CurrentSaveIahOrderItemStatusRequest.AssignedTo" required #Surgeon="ngModel">
                            </CustomDataByRequestType>
                          </div>

                        </div>

                      </div>
                    </div>

                    
                    

                    <!--<div class="row margin-top-3px">

                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                        <div class="row">
                          <div class="col-md-4 text-align-right">

                            <label for="firstName" class="margin-bottom-0px margin-top-7px"> Comments</label>
                          </div>
                          <div class="col-md-4">

                            <textarea class="form-control3 size-2 width-inherit" rows="2" placeholder="Concerns"
                                      name="CurrentSaveIahOrderItemStatusRequest.Comments"
                                      [(ngModel)]="CurrentSaveIahOrderItemStatusRequest.Comments" minlength="1" maxlength="100"
                                      #addconcerns_text1="ngModel" required></textarea>
                            <small class="form-text text-danger"
                                   *ngIf="(!addconcerns_text1.valid && (addconcerns_text1.dirty || addconcerns_text1.touched))">(Required)</small>

                          </div>

                        </div>

                      </div>
                    </div>-->


                  </div>
                </div>
              </div>
              <!--<div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">

            <div class="card margin-bottom-0px background-lightpink">

              <div class="card-body padding-top-0px padding-bottom-0px padding-left-0px padding-right-0px">
                <div class="table-component margin-bottom-0px padding-all-3px" *ngIf="!SelectedpatientDetails.IsReadyForPickup">
                  <div class="table-responsive">


                    <table class="table table-striped margin-left-zero">

                      <thead class="">
                        <tr>
                          <th class=" td-width-107px">Ov.Position</th>
                          <th class="padding-left-5px width-70px">Count</th>
                          <th class="padding-left-5px width-70px">Size</th>
                          <th>Comments</th>

                        </tr>
                      </thead>
                      <tbody class="table-body">

                        <tr>

                          <td>
                            <CodeTypeValue CodeType="OVPS"
                                           id="CurrentSaveFollicularScanOvaryDetailRequest.OvarPos"
                                           [(ngModel)]="CurrentSaveFollicularScanOvaryDetailRequest.OvarPos" SelectedValue=""
                                           name="CurrentSaveFollicularScanOvaryDetailRequest.OvarPos" required>

                            </CodeTypeValue>
                          </td>

                          <td class="td-padding ">

                            <input type="number" class="form-control"
                                   min="1" max="10" id="CurrentSaveFollicularScanOvaryDetailRequest.Count"
                                   [(ngModel)]="CurrentSaveFollicularScanOvaryDetailRequest.Count"
                                   name="CurrentSaveFollicularScanOvaryDetailRequest.Count" #Count="ngModel"
                                   maxlength="100">
                            <small class="form-text text-danger"
                                   *ngIf="(!Count.valid && (Count.dirty || Count.touched) && Count.errors.required )">(Field cannot be left blank)</small>
                            <small class="form-text text-danger"
                                   *ngIf="(!Count.valid && Count.errors.pattern)">(special characters are not allowed)</small>

                          </td>
                          <td class="td-padding ">
                            <input type="text" class="form-control"
                                   min="1" max="10" id="CurrentSaveFollicularScanOvaryDetailRequest.Size"
                                   [(ngModel)]="CurrentSaveFollicularScanOvaryDetailRequest.Size"
                                   name="CurrentSaveFollicularScanOvaryDetailRequest.Size" #Size="ngModel"
                                   maxlength="100">
                            <small class="form-text text-danger"
                                   *ngIf="(!Size.valid && (Size.dirty || Size.touched) && Size.errors.required )">(Field cannot be left blank)</small>
                            <small class="form-text text-danger"
                                   *ngIf="(!Size.valid && Size.errors.pattern)">(special characters are not allowed)</small>
                          </td>

                          <td class="td-padding ">
                            <input type="text" class="form-control"
                                   min="1" max="10" id="CurrentSaveFollicularScanOvaryDetailRequest.Remarks"
                                   [(ngModel)]="CurrentSaveFollicularScanOvaryDetailRequest.Remarks"
                                   name="CurrentSaveFollicularScanOvaryDetailRequest.Remarks" #Remarks="ngModel"
                                   maxlength="100">
                            <small class="form-text text-danger"
                                   *ngIf="(!Remarks.valid && (Remarks.dirty || Remarks.touched) && Remarks.errors.required )">(Field cannot be left blank)</small>
                            <small class="form-text text-danger"
                                   *ngIf="(!Remarks.valid && Remarks.errors.pattern)">(special characters are not allowed)</small>
                          </td>



                        </tr>

                      </tbody>

                    </table>

                  </div>
                </div>
              </div>
            </div>
          </div>-->
            </div>
          </div>
        </form>

      </div>
      <div class="accordion padding-10px" id="accordionExampleSch">
        <form class="form " novalidate="" (ngSubmit)="onSubmitSchedule()" #f="ngForm">
          <div class="card margin-bottom-5px">
            <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingSch">
              <div class="row">
                <div class="col-md-4">
                  <h5 class="mb-0 height-24px">
                    <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseSch" aria-expanded="true" aria-controls="collapseSch">
                      Schedule
                    </button>
                  </h5>
                </div>
                <div class="col-md-8">
                  <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                  <button type="submit" class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>
                </div>
                <!--<div class="col-md-6">
              <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto">Clear</button>
              <button type="submit" class="btn font-size-13px actions-btn-prime margin-right-auto">Save</button>
            </div>-->
              </div>


            </div>

            <div id="collapseSch" class="collapse show" aria-labelledby="headingSch" data-parent="#accordionExampleSch">
              <div class="card-body padding-top-0px padding-bottom-0px margin-left-0px padding-left-0px padding-right-0px">

                <div class="card margin-bottom-0px ">

                  <div class="card-body padding-top-0px padding-bottom-0px padding-left-0px padding-right-0px">

                    <div class="row">

                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                        <div class="row">
                          <div class="col-md-4 text-align-right">

                            <label for="firstName" class="margin-bottom-0px margin-top-7px">Date</label>
                          </div>
                          <div class="col-md-4">
                            <div class="date-form margin-top-5px form-group margin-bottom-0px">
                              <input class="form-control" placeholder="From Date" [minDate]="minDate" [maxDate]="maxDate"
                                     name="SelectedFromDate" [(ngModel)]="SelectedDate" (ngModelChange)="dataChanged($event)" ngbDatepicker #d="ngbDatepicker">

                              <a (click)="d.toggle()" class="nav-link-hand">
                                <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                              </a>

                            </div>
                          </div>

                        </div>

                      </div>
                    </div>

                    <!--<div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-4 text-align-right">
                        <label for="diaplayName" class="margin-bottom-0px margin-top-7px">Requested Quantity</label>
                      </div>

                      <div class="col-md-4">

                        <input type="text" class="form-control"
                               placeholder="Count" maxlength="5" minlength="1" pattern="^[\0-9,._\-?]*$">




                      </div>
                      <div class="col-3  padding-left-0px">
                        <label class="margin-bottom-0px margin-top-10">mg</label>


                      </div>

                    </div>


                  </div>
                </div>

                <div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-4 text-align-right">
                        <label for="diaplayName" class="margin-bottom-0px margin-top-7px"> Issued Quantity</label>
                      </div>

                      <div class="col-md-4">


                        <input type="text" class="form-control"
                               placeholder="Count" maxlength="5" minlength="1" pattern="^[\0-9,._\-?]*$">




                      </div>
                      <div class="col-3  padding-left-0px">
                        <label class="margin-bottom-0px margin-top-10">mg</label>


                      </div>
                    </div>


                  </div>
                </div>-->
                    <div class="row">

                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                        <div class="row">
                          <div class="col-md-4 text-align-right">

                            <label for="firstName" class="margin-bottom-0px margin-top-7px">Time</label>
                          </div>
                          <div class="col-md-4">
                            <input type="time" class="form-control"
                                   id="CurrentSaveIahOrderItemStatusRequest.Time" placeholder="Time"
                                   [(ngModel)]="CurrentSaveIahOrderItemStatusRequest.Time"
                                   name="CurrentSaveIahOrderItemStatusRequest.Time" pattern="^[\sa-zA-Z0-9,._\-?]*$" #ActivityTime="ngModel" />

                          </div>

                        </div>

                      </div>
                    </div>




                  </div>
                </div>
              </div>
              <!--<div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">

            <div class="card margin-bottom-0px background-lightpink">

              <div class="card-body padding-top-0px padding-bottom-0px padding-left-0px padding-right-0px">
                <div class="table-component margin-bottom-0px padding-all-3px" *ngIf="!SelectedpatientDetails.IsReadyForPickup">
                  <div class="table-responsive">


                    <table class="table table-striped margin-left-zero">

                      <thead class="">
                        <tr>
                          <th class=" td-width-107px">Ov.Position</th>
                          <th class="padding-left-5px width-70px">Count</th>
                          <th class="padding-left-5px width-70px">Size</th>
                          <th>Comments</th>

                        </tr>
                      </thead>
                      <tbody class="table-body">

                        <tr>

                          <td>
                            <CodeTypeValue CodeType="OVPS"
                                           id="CurrentSaveFollicularScanOvaryDetailRequest.OvarPos"
                                           [(ngModel)]="CurrentSaveFollicularScanOvaryDetailRequest.OvarPos" SelectedValue=""
                                           name="CurrentSaveFollicularScanOvaryDetailRequest.OvarPos" required>

                            </CodeTypeValue>
                          </td>

                          <td class="td-padding ">

                            <input type="number" class="form-control"
                                   min="1" max="10" id="CurrentSaveFollicularScanOvaryDetailRequest.Count"
                                   [(ngModel)]="CurrentSaveFollicularScanOvaryDetailRequest.Count"
                                   name="CurrentSaveFollicularScanOvaryDetailRequest.Count" #Count="ngModel"
                                   maxlength="100">
                            <small class="form-text text-danger"
                                   *ngIf="(!Count.valid && (Count.dirty || Count.touched) && Count.errors.required )">(Field cannot be left blank)</small>
                            <small class="form-text text-danger"
                                   *ngIf="(!Count.valid && Count.errors.pattern)">(special characters are not allowed)</small>

                          </td>
                          <td class="td-padding ">
                            <input type="text" class="form-control"
                                   min="1" max="10" id="CurrentSaveFollicularScanOvaryDetailRequest.Size"
                                   [(ngModel)]="CurrentSaveFollicularScanOvaryDetailRequest.Size"
                                   name="CurrentSaveFollicularScanOvaryDetailRequest.Size" #Size="ngModel"
                                   maxlength="100">
                            <small class="form-text text-danger"
                                   *ngIf="(!Size.valid && (Size.dirty || Size.touched) && Size.errors.required )">(Field cannot be left blank)</small>
                            <small class="form-text text-danger"
                                   *ngIf="(!Size.valid && Size.errors.pattern)">(special characters are not allowed)</small>
                          </td>

                          <td class="td-padding ">
                            <input type="text" class="form-control"
                                   min="1" max="10" id="CurrentSaveFollicularScanOvaryDetailRequest.Remarks"
                                   [(ngModel)]="CurrentSaveFollicularScanOvaryDetailRequest.Remarks"
                                   name="CurrentSaveFollicularScanOvaryDetailRequest.Remarks" #Remarks="ngModel"
                                   maxlength="100">
                            <small class="form-text text-danger"
                                   *ngIf="(!Remarks.valid && (Remarks.dirty || Remarks.touched) && Remarks.errors.required )">(Field cannot be left blank)</small>
                            <small class="form-text text-danger"
                                   *ngIf="(!Remarks.valid && Remarks.errors.pattern)">(special characters are not allowed)</small>
                          </td>



                        </tr>

                      </tbody>

                    </table>

                  </div>
                </div>
              </div>
            </div>
          </div>-->
            </div>
          </div>
        </form>

      </div>
      <div class="accordion padding-10px" id="accordionExampleSta">
        <form class="form " novalidate="" (ngSubmit)="onSubmitStatus()" #f="ngForm">
          <div class="card margin-bottom-5px">
            <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingSta">
              <div class="row">
                <div class="col-md-4">
                  <h5 class="mb-0 height-24px">
                    <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseSta" aria-expanded="true" aria-controls="collapseSta">
                      Status
                    </button>
                  </h5>
                </div>
                <div class="col-md-8">
                  <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                  <button type="submit" class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>
                </div>
                <!--<div class="col-md-6">
              <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto">Clear</button>
              <button type="submit" class="btn font-size-13px actions-btn-prime margin-right-auto">Save</button>
            </div>-->
              </div>


            </div>

            <div id="collapseSta" class="collapse show" aria-labelledby="headingSta" data-parent="#accordionExampleSta">
              <div class="card-body padding-top-0px padding-bottom-0px margin-left-0px padding-left-0px padding-right-0px">

                <div class="card margin-bottom-0px ">

                  <div class="card-body padding-top-0px padding-bottom-0px padding-left-0px padding-right-0px">

                    

                    
                    <div class="row">

                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                        <div class="row">
                          <div class="col-md-4 text-align-right">

                            <label for="firstName" class="margin-bottom-0px margin-top-7px">Status</label>
                          </div>
                          <div class="col-md-4">


                            <CodeTypeValue CodeType="IAHOS"
                                           id="CurrentSaveIahOrderItemStatusRequest.OrderItemStatus"
                                           [(ngModel)]="CurrentSaveIahOrderItemStatusRequest.OrderItemStatus" SelectedValue=""
                                           name="CurrentSaveIahOrderItemStatusRequest.OrderItemStatus">
                            </CodeTypeValue>

                          </div>

                        </div>

                      </div>
                    </div>

                    


                  </div>
                </div>
              </div>
              <!--<div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">

            <div class="card margin-bottom-0px background-lightpink">

              <div class="card-body padding-top-0px padding-bottom-0px padding-left-0px padding-right-0px">
                <div class="table-component margin-bottom-0px padding-all-3px" *ngIf="!SelectedpatientDetails.IsReadyForPickup">
                  <div class="table-responsive">


                    <table class="table table-striped margin-left-zero">

                      <thead class="">
                        <tr>
                          <th class=" td-width-107px">Ov.Position</th>
                          <th class="padding-left-5px width-70px">Count</th>
                          <th class="padding-left-5px width-70px">Size</th>
                          <th>Comments</th>

                        </tr>
                      </thead>
                      <tbody class="table-body">

                        <tr>

                          <td>
                            <CodeTypeValue CodeType="OVPS"
                                           id="CurrentSaveFollicularScanOvaryDetailRequest.OvarPos"
                                           [(ngModel)]="CurrentSaveFollicularScanOvaryDetailRequest.OvarPos" SelectedValue=""
                                           name="CurrentSaveFollicularScanOvaryDetailRequest.OvarPos" required>

                            </CodeTypeValue>
                          </td>

                          <td class="td-padding ">

                            <input type="number" class="form-control"
                                   min="1" max="10" id="CurrentSaveFollicularScanOvaryDetailRequest.Count"
                                   [(ngModel)]="CurrentSaveFollicularScanOvaryDetailRequest.Count"
                                   name="CurrentSaveFollicularScanOvaryDetailRequest.Count" #Count="ngModel"
                                   maxlength="100">
                            <small class="form-text text-danger"
                                   *ngIf="(!Count.valid && (Count.dirty || Count.touched) && Count.errors.required )">(Field cannot be left blank)</small>
                            <small class="form-text text-danger"
                                   *ngIf="(!Count.valid && Count.errors.pattern)">(special characters are not allowed)</small>

                          </td>
                          <td class="td-padding ">
                            <input type="text" class="form-control"
                                   min="1" max="10" id="CurrentSaveFollicularScanOvaryDetailRequest.Size"
                                   [(ngModel)]="CurrentSaveFollicularScanOvaryDetailRequest.Size"
                                   name="CurrentSaveFollicularScanOvaryDetailRequest.Size" #Size="ngModel"
                                   maxlength="100">
                            <small class="form-text text-danger"
                                   *ngIf="(!Size.valid && (Size.dirty || Size.touched) && Size.errors.required )">(Field cannot be left blank)</small>
                            <small class="form-text text-danger"
                                   *ngIf="(!Size.valid && Size.errors.pattern)">(special characters are not allowed)</small>
                          </td>

                          <td class="td-padding ">
                            <input type="text" class="form-control"
                                   min="1" max="10" id="CurrentSaveFollicularScanOvaryDetailRequest.Remarks"
                                   [(ngModel)]="CurrentSaveFollicularScanOvaryDetailRequest.Remarks"
                                   name="CurrentSaveFollicularScanOvaryDetailRequest.Remarks" #Remarks="ngModel"
                                   maxlength="100">
                            <small class="form-text text-danger"
                                   *ngIf="(!Remarks.valid && (Remarks.dirty || Remarks.touched) && Remarks.errors.required )">(Field cannot be left blank)</small>
                            <small class="form-text text-danger"
                                   *ngIf="(!Remarks.valid && Remarks.errors.pattern)">(special characters are not allowed)</small>
                          </td>



                        </tr>

                      </tbody>

                    </table>

                  </div>
                </div>
              </div>
            </div>
          </div>-->
            </div>
          </div>
        </form>

      </div>
    </div>
    </div>
  </div>

<div class="modal-signup modal-content" *ngIf="ModelType=='Update Status'">
  <div>
    <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">


      <div class="card-header wh-header padding-bottom-0px">

        Update Status

        <button type="button" class="close" data-dismiss="modal"
                (click)="activeModal.dismiss('Cross click')"
                aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="card-body padding-bottom-0px padding-right-0px margin-left-0px padding-left-0px padding-top-0px">
        <div class="row border-top border-bottom bk-color-light margin-left-zero margin-right-0px">
          <div class="col-md-3  text-align-center padding-right-0px padding-left-0px border-right-1px">
            <div class="margin-top-10"><h4 class=" font-weight-bold margin-bottom-0px label-color-consultant font-size-12px">Customer Name</h4></div>
            <div class="margin-bottom-10px"><h4 class="margin-bottom-0px display-inline color-Checkin"> Piyali Sarkar</h4></div>
          </div>
          <div class="col-md-3  text-align-center padding-right-0px padding-left-0px border-right-1px">
            <div class="margin-top-10"><h4 class="font-weight-bold margin-bottom-0px label-color-consultant font-size-12px">Order Id</h4></div>
            <div class="margin-bottom-10px"><h4 class="margin-bottom-0px display-inline color-Assign">#12344</h4></div>
          </div>
          <div class="col-md-3 text-align-center padding-right-0px padding-left-0px border-right-1px">
            <div class="margin-top-10"><h4 class=" font-weight-bold margin-bottom-0px label-color-consultant font-size-12px">Order Date</h4></div>
            <div class="margin-bottom-10px"><h4 class="margin-bottom-0px display-inline">OCT-12-2020</h4> </div>
          </div>
          <div class="col-md-3 text-align-center padding-right-0px padding-left-0px border-right-1px">
            <div class="margin-top-10"><h4 class=" font-weight-bold margin-bottom-0px label-color-consultant font-size-12px">Deliver To</h4></div>
            <div class="margin-bottom-10px"><h4 class="margin-bottom-0px display-inline color-checkout">Nacharam, Hyd</h4></div>
          </div>
        </div>
        <form class="form" novalidate="" (ngSubmit)="onSubmit()" #f="ngForm">
          <div class="modal-body padding-top-0px">








            <div class="row margin-left-auto">
              <div class="col-md-12 padding-l-0px">

                <!--<div class="card-header wh-header card-header-bg padding-left-7px padding-top-6px margin-top-10">
    Emergency Contact(Family)


  </div>-->

                <div class="row font-size-14 margin-top-10">
                  <div class="col-md-4 text-align-right padding-left-0px">
                    <label class="margin-bottom-0px">Last Update Date </label>
                  </div>:
                  <div class="col-md-7  padding-left-10px my-profile-form">

                    <div class="form-group margin-bottom-0px">
                      <!--<CodeTypeValue CodeType="FNSTS"></CodeTypeValue>-->
                      <!--id="CurrentSaveSingleEmbryoGradeInfoRequest.Grade"
        [(ngModel)]="CurrentSaveSingleEmbryoGradeInfoRequest.Grade" SelectedValue="CurrentSaveSingleEmbryoGradeInfoRequest.Grade"
        name="CurrentSaveSingleEmbryoGradeInfoRequest.Grade">-->

                      <h4 class="margin-bottom-0px  margin-top-3px">OCT-23-2020</h4>


                    </div>


                  </div>

                </div>
                <div class="row font-size-14 margin-top-10">
                  <div class="col-md-4 text-align-right padding-left-0px">
                    <label class="margin-bottom-0px">Last Update User </label>
                  </div>:
                  <div class="col-md-7  padding-left-10px my-profile-form">

                    <div class="form-group margin-bottom-0px">
                      <!--<CodeTypeValue CodeType="FNSTS"></CodeTypeValue>-->
                      <!--id="CurrentSaveSingleEmbryoGradeInfoRequest.Grade"
        [(ngModel)]="CurrentSaveSingleEmbryoGradeInfoRequest.Grade" SelectedValue="CurrentSaveSingleEmbryoGradeInfoRequest.Grade"
        name="CurrentSaveSingleEmbryoGradeInfoRequest.Grade">-->

                      <h4 class=" margin-bottom-0px margin-top-3px">Pavan</h4>


                    </div>


                  </div>

                </div>


                <div class="row font-size-14 margin-top-10">
                  <div class="col-md-4 text-align-right padding-left-0px">
                    <label class="margin-bottom-0px">Current Status </label>
                  </div>:
                  <div class="col-md-7  padding-left-10px my-profile-form">

                    <div class="form-group margin-bottom-0px">
                      <!--<CodeTypeValue CodeType="FNSTS"></CodeTypeValue>-->
                      <!--id="CurrentSaveSingleEmbryoGradeInfoRequest.Grade"
        [(ngModel)]="CurrentSaveSingleEmbryoGradeInfoRequest.Grade" SelectedValue="CurrentSaveSingleEmbryoGradeInfoRequest.Grade"
        name="CurrentSaveSingleEmbryoGradeInfoRequest.Grade">-->

                      <h4 class="color-Assign margin-bottom-0px font-weight-bold margin-top-3px">Dispatched</h4>


                    </div>


                  </div>

                </div>
                <div class="row font-size-14 margin-top-10">
                  <div class="col-md-4 text-align-right padding-left-0px">
                    <label class="margin-bottom-0px margin-top-5px">Update Status To </label>
                  </div>
                  <div class="col-md-4  padding-left-10px my-profile-form">

                    <div class="form-group margin-bottom-0px">
                      <!--<CodeTypeValue CodeType="FNSTS"></CodeTypeValue>-->
                      <!--id="CurrentSaveSingleEmbryoGradeInfoRequest.Grade"
        [(ngModel)]="CurrentSaveSingleEmbryoGradeInfoRequest.Grade" SelectedValue="CurrentSaveSingleEmbryoGradeInfoRequest.Grade"
        name="CurrentSaveSingleEmbryoGradeInfoRequest.Grade">-->

                      <CodeTypeValue CodeType="IAHOS">


                      </CodeTypeValue>


                    </div>


                  </div>

                </div>
                <div class="row font-size-14 margin-top-10">
                  <div class="col-md-4 text-align-right padding-left-0px">
                    <label class="margin-bottom-0px margin-top-5px">Comments </label>
                  </div>
                  <div class="col-md-4  padding-left-10px my-profile-form">

                    <div class="form-group margin-bottom-0px">
                      <!--<CodeTypeValue CodeType="FNSTS"></CodeTypeValue>-->
                      <!--id="CurrentSaveSingleEmbryoGradeInfoRequest.Grade"
      [(ngModel)]="CurrentSaveSingleEmbryoGradeInfoRequest.Grade" SelectedValue="CurrentSaveSingleEmbryoGradeInfoRequest.Grade"
      name="CurrentSaveSingleEmbryoGradeInfoRequest.Grade">-->

                      <CodeTypeValue CodeType="FNSTS">


                      </CodeTypeValue>


                    </div>


                  </div>

                </div>



              </div>
            </div>


            <!--<div class="card-footer text-align-center">
        <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto" (click)="activeModal.close('Close click')">Close</button>
      </div>-->


















          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto font-size-13px" (click)="activeModal.close('Close click')">Close</button>
            <button type="submit" class="btn actions-btn-prime float-right font-size-13px margin-right-auto">Save</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
<div class="modal-signup modal-content" *ngIf="ModelType=='Update Status2'">
  <div>
    <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">


      <div class="card-header wh-header padding-bottom-0px">

        Update Status

        <button type="button" class="close" data-dismiss="modal"
                (click)="activeModal.dismiss('Cross click')"
                aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="card-body padding-bottom-0px padding-right-0px margin-left-0px padding-left-0px padding-top-0px">
        <div class="row border-top border-bottom bk-color-light margin-left-zero margin-right-0px">
          <div class="col-md-3  text-align-center padding-right-0px padding-left-0px border-right-1px">
            <div class="margin-top-10"><h4 class=" font-weight-bold margin-bottom-0px label-color-consultant font-size-12px">Patient Name</h4></div>
            <div class="margin-bottom-10px"><h4 class="margin-bottom-0px display-inline color-Checkin" *ngIf="CustomerName"> {{CustomerName}}</h4></div>
          </div>
          <div class="col-md-3  text-align-center padding-right-0px padding-left-0px border-right-1px">
            <div class="margin-top-10"><h4 class="font-weight-bold margin-bottom-0px label-color-consultant font-size-12px">Ivf&#64;Home Order</h4></div>
            <div class="margin-bottom-10px"><h4 class="margin-bottom-0px display-inline color-Assign" *ngIf="OrderCode">#{{OrderCode}}</h4></div>
          </div>
          <div class="col-md-3 text-align-center padding-right-0px padding-left-0px border-right-1px">
            <div class="margin-top-10"><h4 class=" font-weight-bold margin-bottom-0px label-color-consultant font-size-12px">Order Date</h4></div>
            <div class="margin-bottom-10px"><h4 class="margin-bottom-0px display-inline" *ngIf="OrderDate">{{OrderDate | date:'MMM-dd-yyyy'}}</h4> </div>
          </div>
          <div class="col-md-3 text-align-center padding-right-0px padding-left-0px border-right-1px">
            <div class="margin-top-10"><h4 class=" font-weight-bold margin-bottom-0px label-color-consultant font-size-12px">Address</h4></div>
            <div class="margin-bottom-10px td-elipsis2 padding-left-10px"><h4 class="margin-bottom-0px display-inline color-checkout" *ngIf="Address">{{Address}}</h4></div>
          </div>
        </div>
        <form class="form" novalidate="" (ngSubmit)="onSubmitOrder()" #f="ngForm">
          <div class="modal-body padding-top-0px">








            <div class="row margin-left-auto">
              <div class="col-md-12 padding-l-0px">

                <!--<div class="card-header wh-header card-header-bg padding-left-7px padding-top-6px margin-top-10">
                  Emergency Contact(Family)


                </div>-->

                <div class="row font-size-14 margin-top-10">
                  <div class="col-md-4 text-align-right padding-left-0px">
                    <label class="margin-bottom-0px">Last Update Date </label>
                  </div>:
                  <div class="col-md-7  padding-left-10px my-profile-form">

                    <div class="form-group margin-bottom-0px">
                      <!--<CodeTypeValue CodeType="FNSTS"></CodeTypeValue>-->
                      <!--id="CurrentSaveSingleEmbryoGradeInfoRequest.Grade"
                      [(ngModel)]="CurrentSaveSingleEmbryoGradeInfoRequest.Grade" SelectedValue="CurrentSaveSingleEmbryoGradeInfoRequest.Grade"
                      name="CurrentSaveSingleEmbryoGradeInfoRequest.Grade">-->

                      <h4 class="margin-bottom-0px  margin-top-3px" *ngIf="OrderDate">{{OrderDate | date:'MMM-dd-yyyy'}}</h4>


                    </div>


                  </div>

                </div>
                <div class="row font-size-14 margin-top-10">
                  <div class="col-md-4 text-align-right padding-left-0px">
                    <label class="margin-bottom-0px">Last Update User </label>
                  </div>:
                  <div class="col-md-7  padding-left-10px my-profile-form">

                    <div class="form-group margin-bottom-0px">
                      <!--<CodeTypeValue CodeType="FNSTS"></CodeTypeValue>-->
                      <!--id="CurrentSaveSingleEmbryoGradeInfoRequest.Grade"
                      [(ngModel)]="CurrentSaveSingleEmbryoGradeInfoRequest.Grade" SelectedValue="CurrentSaveSingleEmbryoGradeInfoRequest.Grade"
                      name="CurrentSaveSingleEmbryoGradeInfoRequest.Grade">-->

                      <h4 class=" margin-bottom-0px margin-top-3px" *ngIf="CreUser">{{CreUser}}</h4>


                    </div>


                  </div>

                </div>


                <div class="row font-size-14 margin-top-10">
                  <div class="col-md-4 text-align-right padding-left-0px">
                    <label class="margin-bottom-0px">Current Status </label>
                  </div>:
                  <div class="col-md-7  padding-left-10px my-profile-form">

                    <div class="form-group margin-bottom-0px">
                      <!--<CodeTypeValue CodeType="FNSTS"></CodeTypeValue>-->
                      <!--id="CurrentSaveSingleEmbryoGradeInfoRequest.Grade"
                      [(ngModel)]="CurrentSaveSingleEmbryoGradeInfoRequest.Grade" SelectedValue="CurrentSaveSingleEmbryoGradeInfoRequest.Grade"
                      name="CurrentSaveSingleEmbryoGradeInfoRequest.Grade">-->

                      <h4 class="color-Assign margin-bottom-0px font-weight-bold margin-top-3px" *ngIf="Status">{{Status}}</h4>


                    </div>


                  </div>

                </div>
                <div class="row font-size-14 margin-top-10">
                  <div class="col-md-4 text-align-right padding-left-0px">
                    <label class="margin-bottom-0px margin-top-5px">Update Status To </label>
                  </div>
                  <div class="col-md-4  padding-left-10px my-profile-form">

                    <div class="form-group margin-bottom-0px">
                      <!--<CodeTypeValue CodeType="FNSTS"></CodeTypeValue>-->
                      <!--id="CurrentSaveSingleEmbryoGradeInfoRequest.Grade"
  [(ngModel)]="CurrentSaveSingleEmbryoGradeInfoRequest.Grade" SelectedValue="CurrentSaveSingleEmbryoGradeInfoRequest.Grade"
  name="CurrentSaveSingleEmbryoGradeInfoRequest.Grade">-->
                      <CodeTypeValue CodeType="IAHOS"
                                     id="CurrentSaveIahOrderStatusRequest.OrderStatus"
                                     [(ngModel)]="CurrentSaveIahOrderStatusRequest.OrderStatus" SelectedValue=""
                                     name="CurrentSaveIahOrderStatusRequest.OrderStatus">
                      </CodeTypeValue>
                     

                    </div>


                  </div>

                </div>
                <div class="row font-size-14 margin-top-10">
                  <div class="col-md-4 text-align-right padding-left-0px">
                    <label class="margin-bottom-0px margin-top-5px">Comments </label>
                  </div>
                  <div class="col-md-4  padding-left-10px my-profile-form">

                    <div class="form-group margin-bottom-0px">
                      <!--<CodeTypeValue CodeType="FNSTS"></CodeTypeValue>-->
                      <!--id="CurrentSaveSingleEmbryoGradeInfoRequest.Grade"
  [(ngModel)]="CurrentSaveSingleEmbryoGradeInfoRequest.Grade" SelectedValue="CurrentSaveSingleEmbryoGradeInfoRequest.Grade"
  name="CurrentSaveSingleEmbryoGradeInfoRequest.Grade">-->

                      <textarea class="form-control3 size-2 width-inherit" rows="2" placeholder="Concerns"
                                name="CurrentSaveIahOrderStatusRequest.Comments"
                                [(ngModel)]="CurrentSaveIahOrderStatusRequest.Comments" minlength="1" maxlength="100"
                                #addconcerns_text="ngModel" required></textarea>
                      <small class="form-text text-danger"
                             *ngIf="(!addconcerns_text.valid && (addconcerns_text.dirty || addconcerns_text.touched))">(Required)</small>

                    </div>


                  </div>

                </div>



              </div>
            </div>


            <!--<div class="card-footer text-align-center">
              <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto" (click)="activeModal.close('Close click')">Close</button>
            </div>-->


















          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto font-size-13px" (click)="activeModal.close('Close click')">Close</button>
            <button type="submit" class="btn actions-btn-prime float-right font-size-13px margin-right-auto">Save</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
